import { Col, Divider, Row, Typography } from "antd";
import React from "react";
import { MdMyLocation } from "react-icons/md";
import { UPLOADS_URL } from "../../config/constants/api";

const { Title, Text } = Typography;
export default function OngoingRideComponent({ data, status, message }) {
  return (
    <Row justify="center">
      <Col xs={24}>
        <div className="border border-gray-300 py-8 px-4 flex flex-col justify-start items-start sm:pb-64">
          <h5 className="font-tavi text-3xl text-black mb-4">
            Ride Information
          </h5>
          <div className="flex flex-col items-center justify-center w-full">
            <div className="flex justify-start items-center rounded-sm border border-gray-300 bg-white p-3 w-full">
              <MdMyLocation
                size={24}
                className="text-customGold transition-colors"
              />
              <div className="flex flex-col items-start justify-center ml-2 w-full">
                <p className="font-euclid text-sm max-sm:text-xs text-customGold">
                  Driver Location
                </p>

                <p>{data?.driver?.currentLocation?.address}</p>
              </div>
            </div>
            <div className="flex justify-start items-center rounded-sm border border-gray-300 bg-white p-3 w-full">
              <MdMyLocation
                size={24}
                className="text-customGold transition-colors"
              />
              <div className="flex flex-col items-start justify-center ml-2 w-full">
                <p className="font-euclid text-sm max-sm:text-xs text-customGold">
                  Your location
                </p>
                <p>{data?.pickupLocation?.address}</p>
              </div>
            </div>

            <Divider />
            <h2 className="mt-10 mb-4 text-lg font-bold">Driver Details</h2>
            <div className="flex flex-col items-center justify-between gap-2">
              <img
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
                src={UPLOADS_URL + data?.driver?.image}
              ></img>
              <p className="font-bold text-xl">
                {data?.driver?.firstName + " " + data?.driver?.lastName}
              </p>

              <p>Ride Fare : ${Math.round(data?.fare)}</p>
            </div>
            <div>
              <Title
                level={4}
                style={{
                  color:
                    status === "ACCEPTED" || status === "CONFIRMED"
                      ? "#1497E4"
                      : status === "ARRIVED"
                      ? "#09BE51"
                      : status === "STARTED"
                      ? "#09BE51"
                      : status === "ENDED"
                      ? "red"
                      : "red",
                }}
              >
                {message}
              </Title>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}
